import React from "react";
import "../styles/contact.scss";
import FormInput from "./form-input";

class Contact extends React.Component {
  constructor() {
    super();

    this.state = {
      name: "",
      email: "",
      message: "",
      buttonText: "Send",
    };
  }

  handleChange = (event) => {
    const { name, value } = event.target;

    this.setState({ [name]: value });
  };

  render() {
    const { name, email, message, buttonText } = this.state;
    return (
      <div className="page">
        <section className="main1">
          <div className="container">
            <div className="row">
              <p className="intro-heading">
                Got a question? I'd{" "}
                <span role="img" aria-label="love emoji">
                  ❤
                </span>{" "}
                to hear from you.
              </p>
              <div className="form">
                <form
                  className="sign-up-form"
                  action="https://formspree.io/mrgyqldw"
                  method="POST"
                >
                  <FormInput
                    type="text"
                    value={name}
                    onChange={this.handleChange}
                    name="name"
                    label="Full Name"
                    required
                  />
                  <FormInput
                    type="email"
                    value={email}
                    onChange={this.handleChange}
                    name="email"
                    label="Email"
                    required
                  />
                  <label className="msg-label">
                    Message
                  </label>
                  <textarea
                    rows="5"
                    name="message"
                    type="text"
                    value={message}
                    onChange={this.handleChange}
                    required
                  />
                  <button type="submit" value="Send">
                    {buttonText}
                  </button>
                </form>
                <div className="footer">
                  <div className="footer-text">
                    Made with{" "}
                    <span
                      role="img"
                      aria-label="love emoji"
                    >
                      ❤
                    </span>{" "}
                    by Vishal
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Contact;
